import {
    apiRequest,
    angkaKreditCreate,
    checkMonth
} from "../../../../../services/adapters/kepegawaian/pengajuanAngkaKreditService"

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest("post", angkaKreditCreate, {
            body: query
        }, true)
    }

    fetchcheckMonth = async (query) => {
        return await apiRequest("get", checkMonth, {
            params: query
        }, true)
    }

}

export default CreateRepository